<div class="app fade-in">
    <app-header [ngClass]="{ 'fade-in': showHeader }"></app-header>
    <router-outlet *ngIf="hasPreloaded"></router-outlet>
    <app-loading-spinner *ngIf="isLoading"></app-loading-spinner>
    <app-modal *ngIf="connectivityModal" [userClosable]="false">
        <p class="connectivity-modal-text">You appear to be offline. Please check<br>your internet connection to continue using the app</p>
    </app-modal>
</div>